import { Component, ChangeDetectionStrategy } from '@angular/core';

import { SnLocation } from '@lib/api/entities';
import { snListStagger, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnListBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationListComponent extends SnListBaseComponent<SnLocation> {
  constructor() {
    super();
  }

  public trackBy(index: number, item: SnLocation): any {
    return item.id;
  }
}
